import { Badge, Modal, Table } from 'flowbite-react';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useGetSessionRecordingBySessionIdQuery } from 'src/hooks/session.hooks';
import { RecordingStatus, SessionRecording } from 'types';
import { Loader } from 'ui';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	sessionId: string;
}

const SessionRecordingModal = ({ isOpen, onClose, sessionId }: Props) => {
	const [recordings, setRecordings] = useState<SessionRecording[]>([]);

	const { data, isLoading } = useGetSessionRecordingBySessionIdQuery(sessionId);

	useEffect(() => {
		if (data?.recordings) {
			setRecordings(data.recordings as SessionRecording[]);
		}
	}, [data]);

	if (!sessionId) return null;
	if (isLoading) return <Loader />;

	return (
		<Modal dismissible={true} show={isOpen} size="5xl" popup={true} onClose={onClose}>
			<Modal.Header className="dark:bg-[#1f2A37]" />
			<Modal.Body className="dark:bg-[#1f2A37]">
				<div className="pt-2 text-center">
					<div className="mb-8">
						{recordings.length === 0 ? (
							<div className="mx-6 flex flex-col items-center rounded-md dark:bg-gray-900 px-4 py-2 text-base dark:text-white">
								No recordings
							</div>
						) : (
							<Table hoverable>
								<Table.Head>
									<Table.HeadCell>Start Time</Table.HeadCell>
									<Table.HeadCell>End Time</Table.HeadCell>
									<Table.HeadCell>Status</Table.HeadCell>
									<Table.HeadCell>Link</Table.HeadCell>
								</Table.Head>
								<Table.Body>
									{recordings.map((r: any, i) => (
										<Table.Row key={r.id}>
											<Table.Cell>
												<div className="w-48 overflow-hidden text-ellipsis whitespace-nowrap">
													{r?.startTime ? moment(r.startTime).format('DD-MM-YYYY hh:mm a') : ''}
												</div>
											</Table.Cell>
											<Table.Cell>
												<div className="w-48 overflow-hidden text-ellipsis whitespace-nowrap">
													{r?.endTime ? moment(r.endTime).format('DD-MM-YYYY hh:mm a') : ''}
												</div>
											</Table.Cell>
											<Table.Cell>
												{r.status === RecordingStatus.INPROGRESS ? (
													<Badge className="w-max" color="warning">
														{r.status}
													</Badge>
												) : r.status === RecordingStatus.COMPLETED ? (
													<Badge className="w-max" color="success">
														{r.status}
													</Badge>
												) : r.status === RecordingStatus.UPLOADING ? (
													<Badge className="w-max" color="info">
														{r.status}
													</Badge>
												) : (
													<></>
												)}
											</Table.Cell>
											<Table.Cell>
												{r.fileName && (
													<Link
														data-testid={`interview-recordings-modal-link-download-${i}`}
														className="text-base text-[#7777E7]"
														target={'_blank'}
														to={r.fileName ?? ''}
													>
														<div className="w-48 overflow-hidden text-ellipsis whitespace-nowrap">Download</div>
													</Link>
												)}
											</Table.Cell>
										</Table.Row>
									))}
								</Table.Body>
							</Table>
						)}
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default SessionRecordingModal;
